import { IntercomWrapper } from '@pendwa/common-browser/components/Intercom/index.js';
import { Reload as ReloadScreen } from '@pendwa/common-browser/components/Reload/index.js';
import { ScrollToTopOnNavigation } from '@pendwa/common-browser/components/ScrollToTopOnNavigation/index.js';
import { StripeScriptLoader } from '@pendwa/common-browser/components/StripeScriptLoader/index.js';
import { ContextPageDataWrapper } from '@pendwa/common-browser/context/PageData/index.js';
import { ApolloClientWrap } from '@pendwa/common-browser/core/apollo/wrapper.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Toaster } from 'sonner';
import { apolloClient } from '../core/apollo/index.js';
import { Screen as AppScreen } from './screens/App/index.js';

function Root() {
  return (
    <Switch>
      <Route path={rootRoutes.app.main.route} component={AppScreen} />
      <Route component={ReloadScreen} />
    </Switch>
  );
}

export const App = () => {
  return (
    <>
      <Toaster richColors position="top-center" />
      <BrowserRouter>
        <ApolloClientWrap
          client={apolloClient}
          render={() => (
            <>
              <ScrollToTopOnNavigation on_mount on_location_change />
              <ContextPageDataWrapper>
                <StripeScriptLoader />
                <IntercomWrapper>
                  <Root />
                </IntercomWrapper>
              </ContextPageDataWrapper>
            </>
          )}
        />
      </BrowserRouter>
    </>
  );
};
